import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-treated',
    templateUrl: './treated.component.svg',
    styleUrls: ['./treated.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TreatedComponent {}
